import { networkLabel } from "@unizpay/ui";
import { Loader2 } from "lucide-react";
import type { IssuedAddress } from "../types";

/**
 * While the payment confirms (seconds): it arrived, the network is confirming it. Nothing is
 * asked of the payer any more, and the page moves on by itself.
 */
export function ProgressStep({ issued }: { issued: IssuedAddress | null }) {
  return (
    <div className="pt-2 text-center">
      <span className="mx-auto flex size-14 items-center justify-center rounded-full bg-subtle text-fg ring-8 ring-subtle/50">
        <Loader2 aria-hidden="true" className="size-6 animate-spin" />
      </span>
      <h1 className="mt-6 text-xl font-semibold tracking-tight">Payment received</h1>
      <p className="mx-auto mt-2 max-w-sm text-sm leading-relaxed text-fg-muted">
        {issued
          ? `${issued.pay_amount} ${issued.token} is confirming on ${networkLabel(issued.network)}. This usually takes a few seconds.`
          : "Your payment is confirming on the network. This usually takes a few seconds."}
      </p>
    </div>
  );
}
